import React from 'react';
import styles from './CloseInfo.less';


const CloseInfo = () => (
  <div className={styles.info}>
    <div>
      <h1>Dear User,</h1>

      <p>Normet Portal/Smartweb is under maintenance. We are building and migrating data to a new portal. During the migration work the Portal will not be accessible. The new portal is estimated to be up and running by the end of June 2023.</p>
      <p>We will inform all registered users when the new portal is up and running.</p>
      <p>best regards,<br />Normet Connected Solutions</p>
    </div>
  </div>
);


export default CloseInfo;



// WEBPACK FOOTER //
// ./src/components/pages/CloseInfo/CloseInfo.js